import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";
import { ChevronDown } from "lucide-react";

interface CandidateFilterMenuProps<T extends string> {
  label: string;
  value: T;
  options: { value: T; label: string }[];
  onChange: (next: T) => void;
}

export function CandidateFilterMenu<T extends string>({
  label,
  value,
  options,
  onChange,
}: CandidateFilterMenuProps<T>) {
  const selected = options.find((option) => option.value === value);
  const active = value !== options[0]?.value;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="outline"
          className={cn(
            "h-10 px-4 rounded-lg bg-white border-slate-200 text-slate-600 text-sm font-medium hover:border-teal-500 hover:text-teal-700 shadow-sm",
            active && "border-teal-500 text-teal-700 bg-teal-50"
          )}
        >
          {active && selected ? `${label}: ${selected.label}` : label}
          <ChevronDown className="size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        <DropdownMenuRadioGroup
          value={value}
          onValueChange={(next) => {
            const matched = options.find((option) => option.value === next);
            if (matched) onChange(matched.value);
          }}
        >
          {options.map((option) => (
            <DropdownMenuRadioItem key={option.value} value={option.value}>
              {option.label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
